module.exports = __webpack_public_path__ + "img/linkedin-white.28e879b5.svg";